import { Component, ContentChild, HostBinding, Input, OnInit, TemplateRef } from '@angular/core';
import { NgClass, NgForOf, NgIf, NgTemplateOutlet } from '@angular/common';
import { SelectConfig } from './models/select.config';
import { IconComponent } from '../icon/icon.component';
import { CheckboxModule } from 'primeng/checkbox';
import { InputComponent } from '../input/input.component';
import { FormsModule } from '@angular/forms';
import { PaginatorModule } from 'primeng/paginator';
import { RadioButtonModule } from 'primeng/radiobutton';
import { TableModule } from 'primeng/table';
import { ButtonComponent } from '../button/button.component';
import { OutsideClick } from '../../directives/outside-click/outside-click.directive';

@Component({
    selector: 'l-select',
    templateUrl: './select.component.html',
    imports: [
        NgIf,
        NgClass,
        NgTemplateOutlet,
        NgForOf,
        IconComponent,
        CheckboxModule,
        InputComponent,
        FormsModule,
        PaginatorModule,
        RadioButtonModule,
        TableModule,
        ButtonComponent,
        OutsideClick
    ]
})
export class SelectComponent<T> implements OnInit {

  @HostBinding('class')
  public classes = 'block w-full relative';

  @ContentChild('labelTemplate', { static: true })
  public labelTemplate!: TemplateRef<any>;

  @ContentChild('headerTemplate', { static: true })
  public headerTemplate!: TemplateRef<any>;

  @ContentChild('optionTemplate', { static: true })
  public optionTemplate!: TemplateRef<any>;

  @Input({ required: true })
  public key!: string;

  @Input({ required: false })
  public config?: SelectConfig<T>;

  @Input()
  public searchKey?: string;

  @Input()
  public showKey?: string;

  @Input()
  public search: boolean = false;

  @Input()
  public showPagination: boolean = true;

  @Input()
  public multiple: boolean = false;

  @Input()
  public modal: boolean = false;

  @Input()
  public placeholder: string = '';

  @Input()
  public data: T[] = [];

  public isFirstPage: boolean = false;

  public isLastPage: boolean = false;

  public isOpen: boolean = false;

  public selectedContent: any[] = [];

  public page: number = 1;

  public totalPages: number = 0;

  public total = 0;

  public size = 0;

  public blockPagination: boolean = false;

  public searchValue = '';

  public async ngOnInit(): Promise<void> {
    this.data = this.data || [];

    if (this.config?.load) {
      this.data = [];

      const response = await this.config.load(1, '');

      this.blockPagination = response.pageCount <= 1;

      this.size = response.count;
      this.total = response.total;
      this.totalPages = response.pageCount;
      this.data = response.data;
    }
  }

  public async onChangePage(page: number): Promise<void> {
    if (!this.config?.load)
      return;

    this.page = page;

    const response = await this.config.load(this.page, this.searchValue);
    this.data = response.data;
  }

  public nextPage(): void {
    if (this.isLastPage)
      return;

    this.page = this.page + 1;
    this.onChangePage(this.page);
  }

  public prevPage(): void {
    if (this.isFirstPage)
      return;

    this.page = this.page - 1;
    this.onChangePage(this.page);
  }

  public async loadSearch(): Promise<void> {
    if (!this.search)
      return;

    if (this.config?.load) {
      this.data = [];

      const response = await this.config.load(1, this.searchValue);

      this.blockPagination = response.pageCount <= 1;

      this.size = response.count;
      this.total = response.total;
      this.totalPages = response.pageCount;
      this.data = response.data;

      return;
    }
  }

}
